import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Row, Col, Table, Button, Alert, Form } from 'react-bootstrap';
import Moment from 'moment';
import CustomSpinner from '../../components/CustomSpinner';
import ModalConfirm from '../../components/ModalConfirm';
import {
  getBusinessRewardsRequest,
  uploadBusinessRewardsRequest,
  deleteBusinessRewardRequest,
} from '../../actions/index';

class BusinessRewards extends Component {
  static propTypes = {
    deleteReward: PropTypes.func.isRequired,
    getRewards: PropTypes.func.isRequired,
    loadingRewards: PropTypes.bool,
    loadingUpload: PropTypes.bool,
    rewards: PropTypes.array,
    uploadRewards: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedFile: null,
      showDeleteModal: false,
      deleteRewardId: null,
    };
  }

  componentDidMount() {
    this.props.getRewards();
  }

  onFileChange = e => {
    this.setState({ selectedFile: e.target.files[0] ?? null });
  };

  onUpload = () => {
    const { selectedFile } = this.state;
    if (!selectedFile) return;
    this.props.uploadRewards(selectedFile);
    this.setState({ selectedFile: null });
  };

  onDownloadTemplate = () => {
    const csv =
      'rewardTitle,rewardDescription,rewardRate,rewardType,cardBrand,validFrom,validTo\n' +
      '"5% Back on Groceries","Earn 5% cashback on all grocery purchases",5,cashback,Visa,2025-01-01,2025-12-31\n';
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'rewards_template.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  openDeleteModal = rewardId => {
    this.setState({ showDeleteModal: true, deleteRewardId: rewardId });
  };

  closeDeleteModal = () => {
    this.setState({ showDeleteModal: false, deleteRewardId: null });
  };

  confirmDelete = () => {
    const { deleteRewardId } = this.state;
    if (deleteRewardId) this.props.deleteReward(deleteRewardId);
    this.closeDeleteModal();
  };

  render() {
    const { rewards, loadingRewards, loadingUpload } = this.props;
    const { selectedFile, showDeleteModal } = this.state;

    return (
      <Container className="pt-5">
        <Row>
          <Col xs={12} className="d-flex justify-content-between align-items-center">
            <h1 className="h1-list">My Rewards</h1>
            <Button variant="outline-secondary" size="sm" onClick={this.onDownloadTemplate}>
              Download CSV Template
            </Button>
          </Col>

          <Col xs={12} className="mt-4">
            <div className="p-3 border rounded bg-light">
              <h5>Upload Rewards CSV</h5>
              <Form.Group as={Row} className="align-items-center">
                <Col sm={8}>
                  <Form.Control type="file" accept=".csv" onChange={this.onFileChange} />
                </Col>
                <Col sm={4}>
                  <Button
                    variant="primary"
                    onClick={this.onUpload}
                    disabled={!selectedFile || loadingUpload}
                  >
                    {loadingUpload ? 'Uploading…' : 'Upload'}
                  </Button>
                </Col>
              </Form.Group>
              <small className="text-muted">
                CSV must have columns: rewardTitle, rewardDescription, rewardRate, rewardType,
                cardBrand, validFrom, validTo
              </small>
            </div>
          </Col>

          <Col xs={12} className="mt-4">
            {loadingRewards && <CustomSpinner />}

            {!loadingRewards && rewards.length === 0 && (
              <Alert variant="info">No active rewards. Upload a CSV to add rewards.</Alert>
            )}

            {!loadingRewards && rewards.length > 0 && (
              <Table responsive bordered>
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Description</th>
                    <th>Rate</th>
                    <th>Type</th>
                    <th>Card Brand</th>
                    <th>Valid From</th>
                    <th>Valid To</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {rewards.map(reward => (
                    <tr key={reward.id}>
                      <td>{reward.rewardTitle}</td>
                      <td>{reward.rewardDescription}</td>
                      <td>{reward.rewardRate != null ? `${reward.rewardRate}%` : '—'}</td>
                      <td>{reward.rewardType}</td>
                      <td>{reward.cardBrand || 'Any'}</td>
                      <td>
                        {reward.validFrom ? Moment(reward.validFrom).format('MM/DD/YYYY') : '—'}
                      </td>
                      <td>{reward.validTo ? Moment(reward.validTo).format('MM/DD/YYYY') : '—'}</td>
                      <td>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => this.openDeleteModal(reward.id)}
                        >
                          Remove
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Col>
        </Row>

        <ModalConfirm
          title="Remove Reward"
          message="Are you sure you want to remove this reward? It will no longer be visible to users."
          successText="Remove"
          show={showDeleteModal}
          onCancel={this.closeDeleteModal}
          onSuccess={this.confirmDelete}
        />
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    rewards: state.business.rewards,
    loadingRewards: state.business.loadingRewards,
    loadingUpload: state.business.loadingUpload,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getRewards: () => dispatch(getBusinessRewardsRequest()),
    uploadRewards: file => dispatch(uploadBusinessRewardsRequest(file)),
    deleteReward: rewardId => dispatch(deleteBusinessRewardRequest(rewardId)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BusinessRewards);
